import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link as GatsbyLink } from 'gatsby';
import Link from './Link';
import { LOGIN_URL, PARTICIPANT_SIGNUP_URL, SIGNUP_URL, isParticipantPage } from '../lib/links';

const LINKS = [
  { to: '/interviews', label: 'Interviews' },
  { to: '/analysis', label: 'Analysis' },
  { to: '/swarm', label: 'Swarm' },
  { to: '/pricing', label: 'Pricing' },
];

export default function Nav({ pathname }: { pathname: string }) {
  const signup = isParticipantPage(pathname) ? PARTICIPANT_SIGNUP_URL : SIGNUP_URL;
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Phone and tablet widths hide the links row, so a menu button carries them (and Log in).
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    const onResize = () => { if (window.innerWidth > 1080) setOpen(false); };
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
    };
  }, [open]);
  const close = () => setOpen(false);

  return (
    <header className={'nav' + (scrolled || open ? ' is-scrolled' : '')} id="nav">
      <div className="inner">
        <Link className="brand" to="/" aria-label="User Evaluation, home">
          <svg className="wordmark" width="118" height="20" viewBox="0 0 790.65 132" aria-hidden="true" focusable="false">
            <use href="#ue-wordmark" />
          </svg>
        </Link>
        <nav className="nav-links" aria-label="Primary">
          {LINKS.map((l) => (
            <GatsbyLink key={l.to} to={l.to} partiallyActive activeStyle={{ borderBottomColor: '#1A1A1A' }}>
              {l.label}
            </GatsbyLink>
          ))}
        </nav>
        <div className="nav-right">
          <Link className="lnk" to={LOGIN_URL}>Log in</Link>
          <Link className="btn btn-dark" to={signup}>Start free</Link>
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={open}
            aria-controls="nav-menu"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="nav-menu" id="nav-menu" aria-label="Menu">
          {LINKS.map((l) => (
            <GatsbyLink key={l.to} to={l.to} onClick={close}>{l.label}</GatsbyLink>
          ))}
          <Link to={LOGIN_URL} onClick={close}>Log in</Link>
        </nav>
      )}
    </header>
  );
}
